import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import { API_URL } from '../utils/constants';

export const getFloorplanUploadSignedUrl = async ({
  projectId,
  fileName,
  contentType,
}) => {
  const apiPath = `files/upload-signed-url/project-bank/${projectId}/floorplans`;

  const body = { fileName, contentType };

  const request = {
    url: `${API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    data: body,
  };

  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);
  return response.data;
};
